let CancelToken;
let source;

const Config = require('~/config/default.env').default;

export default {
  namespaced: true,
  state: {
    product: [],
    productTitle: null,
    loading: true,
    hasMore: true,
    currentPage: 1,
  },
  mutations: {
    SET_PRODUCT(state, data) {
      state.product = data;
    },
    APPEND_PRODUCT(state, data) {
      state.product = [...state.product, ...data];
    },
    SET_PRODUCT_TITLE(state, data) {
      state.productTitle = data;
    },
    SET_LOAD_PRODUCT(state, data) {
      state.loading = data;
    },
    SET_HAS_MORE(state, data) {
      state.hasMore = data;
    },
    SET_CURRENT_PAGE(state, data) {
      state.currentPage = data;
    },
    RESET_PRODUCTS(state) {
      state.product = [];
      state.currentPage = 1;
      state.hasMore = true;
    },
  },
  actions: {
    getOurCuratedProducts({ commit, state, dispatch, rootState, rootGetters }, isLoadMore = false) {
      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();

      if (!isLoadMore) {
        commit('RESET_PRODUCTS');
      }

      const filter = {
        is_reviewed: true,
        is_use_filter: true,
      };

      const limit = 10;
      const skip = isLoadMore ? (state.currentPage - 1) * limit : 0;

      const params = {
        filter,
        limit: limit,
        skip: skip,
        section: 'TrendingProducts',
      };

      if (rootState.$_Review.queryString.sort) {
        params.sort = rootState.$_Review.queryString.sort;
      }

      if (rootState.$_Review.queryString.brands) {
        params.filter['brand.id'] = {
          $in: rootState.$_Review.queryString.brands.split(','),
        };
      }

      if (rootState.$_Review.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_Review.queryString.tags.split(','),
        };
      }

      if (rootState.$_Review.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_Review.queryString.origins.split(','),
        };
      }

      if (rootState.$_Review.queryString.category) {
        params.filter['categories.id'] = {
          $in: rootState.$_Review.queryString.category,
        };
      }

      if (rootState.$_Review.queryString.rating) {
        const filterQuery = rootState.$_Review.queryString.rating.split(',') || [];
        const rating = [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          if (filterQuery.length > 1) {
            rating.push({
              'review_stats.average_rating': {
                $gte: intRating,
                $lte: intRating + 0.999,
              },
            });
          } else {
            rating.push({
              'review_stats.average_rating': { $gte: intRating },
            });
            rating.push({
              'review_stats.average_rating': { $lte: intRating + 0.999 },
            });
          }
        });
        if (filterQuery.length > 1) {
          params.filter['$and'] = [{ $or: rating }];
        } else {
          params.filter['$and'] = rating;
        }
      }

      if (rootState.$_Review.queryString.available_for) {
        if (
          rootState.$_Review.queryString.available_for.includes('sociolla') &&
          rootState.$_Review.queryString.available_for.includes('lulla')
        ) {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = true;
        } else if (rootState.$_Review.queryString.available_for.includes('lulla')) {
          params.filter['is_active_in_lulla'] = true;
        } else {
          params.filter['is_active_in_sociolla'] = true;
        }
      }

      const paramSearch = { params: params, cancelToken: source.token };

      const productsRequest = axios.get(`${Config.MS_SOCO_PUBLIC_API_URL}/products/featured/trending`, paramSearch);

      const requests = [productsRequest];
      if (!isLoadMore) {
        const titleRequest = axios.get(`${Config.MS_SOCO_PUBLIC_API_URL}/products/featured/trending/title`, {
          cancelToken: source.token,
        });
        requests.push(titleRequest);
      }

      return Promise.all(requests)
        .then((responses) => {
          const products = responses[0].data.data;
          const title = !isLoadMore ? responses[1] && responses[1].data.data : state.productTitle;

          const hasMore = products.length === limit;

          if (isLoadMore) {
            commit('APPEND_PRODUCT', products);
          } else {
            commit('SET_PRODUCT', products);
            commit('SET_PRODUCT_TITLE', title);
          }

          commit('SET_HAS_MORE', hasMore);
          commit('SET_CURRENT_PAGE', isLoadMore ? state.currentPage + 1 : 2);
          commit('SET_LOAD_PRODUCT', false);

          return {
            products: state.product,
            title,
            hasMore,
          };
        })
        .catch((err) => {
          if (!isLoadMore) {
            commit('SET_PRODUCT', []);
            commit('SET_PRODUCT_TITLE', null);
          }
          commit('SET_LOAD_PRODUCT', false);
        });
    },

    loadMoreProducts({ dispatch, state }) {
      if (state.hasMore && !state.loading && state.currentPage <= 2) {
        return dispatch('getOurCuratedProducts', true);
      }
    },
  },
  getters: {
    getProductTitle: (state) => state.productTitle,
    getProducts: (state) => state.product,
    isLoading: (state) => state.loading,
    hasMore: (state) => state.hasMore,
    currentPage: (state) => state.currentPage,
  },
};
